import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';
import type { DefaultComponentProps } from '../types';

type PopupContextType = {
  isOpen: boolean;
  index: number;
  open: (nextIndex: number) => void;
  close: () => void;
};

const PopupContext = createContext<PopupContextType>({
  isOpen: false,
  index: -1,
  open: () => {},
  close: () => {}
});

export function PopupProvider({ children }: DefaultComponentProps) {
  const [index, setIndex] = useState(-1);

  const open = useCallback((nextIndex: number) => {
    setIndex(nextIndex);
  }, []);
  const close = useCallback(() => {
    setIndex(-1);
  }, []);

  const value: PopupContextType = useMemo(
    () => ({ isOpen: index !== -1, index, open, close }),
    [index, open, close]
  );

  return (
    <PopupContext.Provider value={value}>{children}</PopupContext.Provider>
  );
}

export const usePopup = () => useContext<PopupContextType>(PopupContext);
